import React from 'react';
import { Users, GraduationCap, Building2, ClipboardList } from 'lucide-react';

const cardConfig = [
  {
    title: 'Total Staff',
    key: 'totalStaff',
    icon: Users,
    cardBg: 'bg-blue-50',
    borderColor: 'border-blue-100',
    valueColor: 'text-blue-600',
    iconColor: 'text-purple-600',
  },
  {
    title: 'Teaching Staff',
    key: 'teachingStaff',
    icon: GraduationCap,
    cardBg: 'bg-emerald-50',
    borderColor: 'border-emerald-100',
    valueColor: 'text-teal-700',
    iconColor: 'text-purple-700',
  },
  {
    title: 'Non-Teaching Staff',
    key: 'nonTeachingStaff',
    icon: Building2,
    cardBg: 'bg-orange-50',
    borderColor: 'border-orange-100',
    valueColor: 'text-orange-600',
    iconColor: 'text-sky-500',
  },
  {
    title: 'Class Teachers',
    key: 'classTeachers',
    icon: ClipboardList,
    cardBg: 'bg-purple-50',
    borderColor: 'border-purple-100',
    valueColor: 'text-purple-600',
    iconColor: 'text-orange-400',
  },
];

const StaffStatsCards = ({
  stats
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      {cardConfig.map((item) => {
        const Icon = item.icon;

        return (
          <div
            key={item.title}
            className={`${item.cardBg} ${item.borderColor} border rounded-2xl px-6 py-5`}
          >
            <div className="flex items-center gap-4">
              <Icon className={`w-7 h-7 ${item.iconColor}`} />

              <div>
                <h3 className={`text-4xl font-bold ${item.valueColor}`}>
                  {stats[item.key]}
                </h3>

                <p className="text-sm text-gray-600 mt-1">
                  {item.title}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StaffStatsCards;